export default {
  __name: 'CopyLink',
  props: ['href', 'label', 'copy'],
  setup: function setup(__props) {
    var props = __props;
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n,
      $toastStore = _useNuxtApp.$toastStore;
    function copyUrl() {
      var inp = document.createElement('input');
      document.body.appendChild(inp);
      inp.value = props.copy;
      inp.select();
      document.execCommand('copy');
      document.body.removeChild(inp);
      $toastStore.add({
        title: $i18n.t('toast.contactCopied'),
        closable: true,
        icon: 'icon-ic-copy'
      });
    }
    return {
      __sfc: true,
      props: props,
      $i18n: $i18n,
      $toastStore: $toastStore,
      copyUrl: copyUrl
    };
  }
};